import { useTokenStore } from '../store/token'
import { useGlobalStore } from '../store/global'

// Check if token is present, if not login and store token
export default async function (to, from) {  

  const tokenStore = useTokenStore();
  const globalStore = useGlobalStore();
  const nuxtApp = useNuxtApp()

  if (to.path == "/auth/login" || to.path == "/auth/grant") {
    return
  }

  // === TOKEN RETRIEVAL WITH COMPREHENSIVE FALLBACK ===
  let accessToken: string | undefined
  let tokenSource = ""

  // Method 1: Check in query params (standard OAuth redirect)
  if (to.query?.access_token) {
    accessToken = to.query.access_token as string
    tokenSource = "query"
  }

  // Method 2: Check in hash (for hash-based OAuth flows)
  if (!accessToken && to.hash) {
    const hashMatch = to.hash.match(/access_token=([^&]+)/)
    if (hashMatch && hashMatch[1]) {
      accessToken = hashMatch[1]
      tokenSource = "hash"
    }
  }

  // Method 3: Check in fullPath (legacy support)
  if (!accessToken && to.fullPath?.includes('access_token=')) {
    const pathMatch = to.fullPath.split("access_token=")
    if (pathMatch.length === 2) {
      accessToken = pathMatch[1].split('&')[0].split('#')[0]
      tokenSource = "fullPath"
    }
  }

  // Method 4: Check in path (last resort fallback)
  if (!accessToken && to.path?.includes('access_token=')) {
    const pathOnlyMatch = to.path.split("access_token=")
    if (pathOnlyMatch.length === 2) {
      accessToken = pathOnlyMatch[1].split('&')[0].split('#')[0]
      tokenSource = "path"
    }
  }

  if (accessToken) {
    const { data: login, error } = await useFetch('/authentication', {
      method: 'POST',
      baseURL: globalStore.apiBase,
      body: {
        strategy: "jwt",
        accessToken: accessToken
      },
      //pick: ['accessToken']
    });

    if (error.value) {
      console.error("❌ [AUTH] Authentication API error:", error.value)
      return navigateTo("/auth/login")
    }

    if (login.value && login.value.accessToken) {
      sessionStorage.setItem("myquote-login", JSON.stringify(login.value));
      tokenStore.updateToken(login.value.accessToken);
      await globalStore.updateUser(login.value.user);

      if ( login.value.user.email!="julien.blanchard@ext.hermes.com" && !nuxtApp.$isUserRoleGreaterThan("sales_associate_front")) {
        return navigateTo("/auth/grant")
      } else {
        return navigateTo("/")
      }

    } else {
      console.error("❌ [AUTH] Authentication response missing accessToken")
      return navigateTo("/auth/login")
    }
  }

  // === CHECK EXISTING SESSION ===
  const loginStr = sessionStorage.getItem("myquote-login")
  const login: any = loginStr ? JSON.parse(loginStr) : null

  if (!login) {
    return navigateTo("/auth/login")
  }

  // Check if token exists and is not expired (with 100 second safety margin)
  const tokenExp = login?.authentication?.payload?.exp
  const now = Date.now()
  const expTime = tokenExp ? tokenExp * 1000 : 0
  const isTokenValid = tokenExp && expTime > (now + 100000)

  if (login && login.accessToken && isTokenValid) {
    if (!login.user || !login.user.role) {
      return navigateTo("/auth/grant")
    }

    // Synchronize stores from sessionStorage (source of truth)
    tokenStore.updateToken(login.accessToken);
    await globalStore.updateUser(login.user);
  } else {
    return navigateTo("/auth/login")
  }

  return;
}
